import React, { Fragment, FunctionComponent, ReactNode } from 'react';

import Body from '@bitcoin-portal/verse-web-components/dist/Body';
import H3 from '@bitcoin-portal/verse-web-components/dist/H3';
import Line from '@bitcoin-portal/verse-web-components/dist/Icons/Line';
import { colors } from '@bitcoin-portal/verse-web-components/dist/themes/colors';

import { Step } from '../Step';
import { AnimationWrapper, Header, ViewWrapper } from './styled';

interface TxPendingProps {
  title: string;
  loaderAnimation: ReactNode;
  steps: StepProps[];
  footnote: string;
}

export const TxPending: FunctionComponent<TxPendingProps> = ({
  title,
  loaderAnimation,
  steps,
  footnote,
}) => {
  return (
    <ViewWrapper>
      <Header>
        <H3 style={{ padding: '16px 0 8px' }}>{title}</H3>
      </Header>
      <AnimationWrapper>{loaderAnimation}</AnimationWrapper>
      <div style={{ marginTop: 40 }}>
        {steps.map((step, idx) => (
          // eslint-disable-next-line react/no-array-index-key
          <Fragment key={`${step.title}-${idx}`}>
            {idx !== 0 && (
              <Line color={colors.shade30} style={{ padding: '12px 0' }} />
            )}
            <Step {...step} />
          </Fragment>
        ))}
      </div>
      <Body
        size="small"
        style={{
          paddingTop: 40,
          textAlign: 'center',
          color: colors.shade90,
        }}
      >
        {footnote}
      </Body>
    </ViewWrapper>
  );
};

export default TxPending;
